module.exports = __webpack_public_path__ + "static/bg-welcome-2-2b88f674d81975fe6168c001d290636d.webp";